module.exports = __webpack_public_path__ + "static/media/game.af7e6365.jpg";